// File for logic corresponding to sidebar nav component
import { Component } from 'js-component-framework';
import isOutOfViewport from '../../js/utils/isOutOfViewport';

/**
 * Component for sidebar nav
 */
export default class SidebarNav extends Component {
  static id = 0;

  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    this.constructor.id += 1;

    const {
      navButton,
      navContent,
      navSubMenus,
    } = this.children;

    this.initCurrentPage();
    this.initNavToggle(navButton, navContent);
    this.initSubMenus(navSubMenus);
  }

  /**
   * Set up current page highlight
   */
  initCurrentPage() {
    const {
      navItems,
    } = this.children;

    const currentPathname = window.location.pathname;

    navItems.forEach((navItem) => {
      const itemPathname = new URL(navItem.href);

      if (itemPathname.pathname === currentPathname) {
        navItem.classList.add('current-page');
        navItem.closest('li.wp-block-navigation-submenu')?.classList.add('current-submenu');
      }
    });
  }

  /**
   * Set up nav toggle
   */
  initNavToggle(navButton, navContent) {
    navButton.setAttribute('aria-controls', `sidebar-nav-content-${this.constructor.id}`);
    navButton.setAttribute('id', `sidebar-nav-button-${this.constructor.id}`);
    navContent.setAttribute('id', `sidebar-nav-content-${this.constructor.id}`);
    navContent.setAttribute('aria-labelledby', `sidebar-nav-button-${this.constructor.id}`);

    navButton.addEventListener('click', () => {
      if (navButton.getAttribute('aria-expanded') === 'false') {
        this.element.classList.add('is-open');
        navButton.setAttribute('aria-expanded', 'true');
      } else {
        this.element.classList.remove('is-open');
        navButton.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* eslint-disable-next-line class-methods-use-this */
  initSubMenus(navSubMenus) {
    navSubMenus.forEach((toggle) => {
      const subMenuToggle = toggle.querySelector('.wp-block-navigation-submenu__toggle');

      subMenuToggle?.addEventListener('click', () => {
        if (subMenuToggle.getAttribute('aria-expanded') === 'false') {
          const toggleContent = toggle.querySelector('.wp-block-navigation-submenu');
          const isOut = isOutOfViewport(toggleContent);

          if (isOut.any) {
            toggle.classList.add('anchor-right');
          }
        } else {
          setTimeout(() => {
            toggle.classList.remove('anchor-right');
          }, 100);
        }
      });
    });
  }
}
